import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionDescription from "../general/NtSectionDescription";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import { useMobile } from "../../../hooks/useMobile";

function NtGuestVideoSection({}) {
  const isMobile = useMobile();
  return (
    <NtMarketingSectionContainer
      style={[styles.container]}
      backgroundImage={require("../../../assets/images/marketing/63eabb18fbe84142b5656a197e00cec5aeb7656a.jpg")}
    >
      <View
        style={{
          flexDirection: isMobile ? "column" : "row",
          flex: 1,
        }}
      >
        {/* left side */}
        <View
          style={{
            flex: isMobile ? 0.5 : 1,
            paddingLeft: 15,
            paddingRight: 15,
            justifyContent: "center",
          }}
        >
          <NtSectionTitle style={{ textAlign: "left" }}>
            GUEST-VIDEO
          </NtSectionTitle>
          <NtSectionDescription style={{ marginTop: 15 }}>
            Onboard/Ship to Ship/Ship to Shore
          </NtSectionDescription>
          <NtSectionDescription style={{ marginTop: 15 }}>
            Passengers can conduct real-time video calls with other passengers
            on the same ship
          </NtSectionDescription>
        </View>

        {/* right side */}
        <View
          style={{
            flex: 1,
            alignItems: "center",
            justifyContent: isMobile ? "flex-start" : "center",
          }}
        >
          <Image
            style={[
              {
                width: 150,
                height: 300,
                resizeMode: "contain",
              },
            ]}
            source={require("../../../assets/images/marketing/7afffde683a9bd23580f12ed3b03d5a71d7a944e.png")}
          />
        </View>
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    height: 600,
  },
});

export default NtGuestVideoSection;
